import type { UploadedFile } from 'models';
import { Button } from 'ui';

type P = {
  attachment: UploadedFile;
};

const SaveSingleAttachmentButton = ({ attachment }: P) => (
  <Button
    navigate={{ external: true, to: attachment.downloadUrl }}
    onClick={(event) => {
      event.stopPropagation();
    }}
    type="link-primary"
  >
    Save
  </Button>
);

export default SaveSingleAttachmentButton;
